import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';

export interface IPasswordValidation {
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  characters: boolean;
}

const PasswordValidation = ({
  uppercase,
  lowercase,
  number,
  characters,
}: IPasswordValidation) => (
  <Flex
    direction="column"
    width="100%"
    // @ts-expect-error
    p="16px"
    mt="10px"
    style={{
      border: `1px solid ${color.downgray}`,
      borderRadius: '8px',
    }}
  >
    <div>
      <Text color="#858585">Password has to include:</Text>
    </div>
    {/* @ts-expect-error */}
    <Flex justify="space-around" pt="18px" width="100%">
      <Flex direction="column" height="54px" align="center">
        <Image
          src={
            uppercase
              ? '/icon/password-check.svg'
              : '/icon/password-uppercase.svg'
          }
          alt="password-uppercase"
        />
        <Text color="#858585" size="13px">
          Uppercase
        </Text>
      </Flex>
      <Flex direction="column" height="54px" align="center">
        <Image
          src={
            lowercase
              ? '/icon/password-check.svg'
              : '/icon/password-lowercase.svg'
          }
          alt="password-lowercase"
        />
        <Text color="#858585" size="13px">
          Lowercase
        </Text>
      </Flex>
      <Flex direction="column" height="54px" align="center">
        <Image
          src={
            number ? '/icon/password-check.svg' : '/icon/password-number.svg'
          }
          alt="password-number"
        />
        <Text color="#858585" size="13px">
          Number
        </Text>
      </Flex>
      <Flex direction="column" height="54px" align="center">
        <Image
          src={
            characters
              ? '/icon/password-check.svg'
              : '/icon/password-characters.svg'
          }
          alt="password-characters"
        />
        <Text color="#858585" size="13px">
          8+ Characters
        </Text>
      </Flex>
    </Flex>
  </Flex>
);

export default PasswordValidation;
